import React from 'react';
import { CtaButton } from './CtaButton';
import { ImageSlot } from './ImageSlot';
import { cta, hero, productImages } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-night" data-id="element-91" data-mp="9ktetq07k6yt">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: 'linear-gradient(to right, #f7f2e8 1px, transparent 1px), linear-gradient(to bottom, #f7f2e8 1px, transparent 1px)',
      backgroundSize: '72px 72px'
    }} data-id="element-92" data-mp="9l32h6xs621c" />

      <div className="relative mx-auto max-w-4xl px-4 pb-14 pt-10 text-center sm:px-6 lg:pb-20 lg:pt-16" data-id="element-93" data-mp="sb1c3rh88373">
        <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold-soft sm:text-sm" data-id="element-94" data-mp="ncq31iyr9wpx">
          {hero.eyebrow}
        </p>

        <h1 className="mx-auto mt-4 max-w-3xl font-display text-[2.5rem] font-semibold uppercase leading-[1.05] tracking-tight text-parchment sm:text-6xl" data-id="element-95" data-mp="3d2tqbf4z2uh6">
          Botiquín <span className="text-gold-soft" data-id="element-96" data-mp="3j9kalakrlffl">Espiritual</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl font-sans text-base leading-relaxed text-parchment/75 sm:text-lg" data-id="element-97" data-mp="3o7bzrwu0yng3">
          {hero.subtitle}
        </p>

        <ImageSlot src={productImages.hero} alt={productImages.heroAlt} label="Mockup principal del Botiquín Espiritual" className="mx-auto mt-8 w-[94%] max-w-2xl overflow-hidden rounded-2xl shadow-[0_24px_60px_rgba(0,0,0,0.5)] sm:w-full" data-id="element-98" data-mp="399tckywzwiar" />

        <div className="mx-auto mt-9 max-w-md" data-id="element-99" data-mp="359j6lm97drvw">
          <CtaButton size="block" href="#oferta" data-id="element-100" data-mp="2qjv4iit76p74">
            {cta.label}
          </CtaButton>
          <p className="mt-3 font-sans text-xs text-parchment/60 sm:text-sm" data-id="element-101" data-mp="2viy2xkeo9x64">
            {cta.microcopy}
          </p>
        </div>
      </div>
    </header>;
}